const JAPAN_POSTAL_CODE_REGEXP = /(\d{7})|(\d{3}-\d{4})/;
export function extractJapanPostalCode(text) {
    return text.match(JAPAN_POSTAL_CODE_REGEXP)?.[0];
}

//# sourceMappingURL=postal-code.js.map